import {useMatrixContext} from '#/state/matrix'

export function useMatrixClient() {
  const {client, status, error, isConnected, isSyncing} = useMatrixContext()
  return {client, status, error, isConnected, isSyncing}
}
